export const Default = () => ({

    benchmarkFiltersAnalysis: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: [
            'self',
            'manager',
            'direct report',
            'peer',
            "team member",
            "client",
            "cross-functional partner",
            'other'
        ]
    },

    fetchOrganizationConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    updateOrgConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    benchmarkFilters: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: [
            'self',
            'manager',
            'direct report',
            'peer',
            "team member",
            "client",
            "cross-functional partner",
            'other'
        ]
    },


    fetchTotalFeedbackProvidersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchTotalFeedbackProvidersStrengthAndDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    fetchCantAnswerResponseApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },
    fetchTopStrengthAndTopDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchRaterHeatmapApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchSurveyLists: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

});